<template>
  <div class="m-4">
    <div class="flex flex-col items-center text-white mt-20" v-if="!errorUltimaOperacion">
      <div>
        <svg viewBox="0 0 20 20" fill="currentColor" class="w-32 h-32">
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
      <div class="mt-4">Su contraseña ha sido cambiada exitosamente</div>
    </div>
    <div class="flex flex-col items-center text-white mt-20" v-if="errorUltimaOperacion">
      <div>
        <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="times-circle" class="w-32 h-32" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path
            fill="currentColor"
            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
          ></path>
        </svg>
      </div>
      <div class="mt-4">No se pudo cambiar la contraseña. Verifique que la contraseña actual sea correcta.</div>
    </div>
    <div><button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Inicio</button></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  methods: {
    inicio() {
      this.$router.push("/menu");
    }
  },
  computed: {
    ...mapState({
      errorUltimaOperacion: state => state.mensajeErrorUltimaOperacion
    })
  }
};
</script>
